import React from "react"
import { AuthNavUser } from "utils/assets"
import AdminForm from "./AdminForm"
import { useQuery, useQueryClient } from "react-query"
import http from "services/httpService"
import { BASE_URL } from "services"
import { useState } from "react"
import { useRef } from "react"
import { uploadAdminDp } from "services/UserService"


const AdminProfile = () => {
	const [, setDp] = useState(null)
	const profileRef = useRef()
	const queryClient = useQueryClient()
	const url = `${BASE_URL}/admin/who_i_am`
	const fetcher = async () => {
		const res = await http.get(url)
		return res?.data?.data
	}

	const handleChange = e => {
		if (e.target.files.length > 0) {
			setDp(e.target.files)
			uploadProfile(e.target.files[0])
		} else {
			setDp(null)
		}
	}

	function PickImage() {
		profileRef.current.click()
	}

	const { data: userProfile } = useQuery("profile", fetcher)

	const uploadProfile = async file => {
		const formData = new FormData()
		formData.append("avatar", file)
		formData.set("id", userProfile?.id)
		const response = await uploadAdminDp(formData)
		if (!response.error) {
			queryClient.invalidateQueries("profile")
		}
	}
	return (
		<main>
			<header className="mb-4 bg-white p-6 rounded-lg">
				<div>
					<div className="relative h-[120px] w-[120px] mb-2 rounded-full shadow-lg">
						<img className="w-full absolute h-full rounded-full" src={userProfile?.avatar?.url ? userProfile?.avatar?.url : AuthNavUser} alt="byshelb" />
						<button onClick={PickImage} className="shadow-lg absolute bottom-1 -right-1 bg-white h-8 w-8 rounded-full flex items-center justify-center border">
							<i className="bi bi-camera-fill text-gray-500"></i>
						</button>
					</div>
					<input style={{ display: "none" }} ref={profileRef} type="file" accept=".png, .jpg, .jpeg" onChange={handleChange} />
					<div>
						<div>
							<p className="text-lg">
								{`${userProfile?.surname} ${userProfile?.first_name}`} {userProfile?.middle_name}
							</p>
							<span className="text-xl text-primary font-bold" style={{ marginTop: "-29px" }}>
								Role &rarr; &nbsp;
								{userProfile?.admin_role === "es"
									? "Executive Secretary"
									: userProfile?.admin_role === "lo"
									? "Loan Officer"
									: userProfile?.admin_role === "lph"
									? "Loan Processing Head"
									: userProfile?.admin_role === "la"
									? "Auditor"
									: userProfile?.admin_role === "fdo"
									? "Front Desk Officer"
									: userProfile?.admin_role === "blog"
									? "Blogger"
									: userProfile?.admin_role === "acc"
									? "Accountant"
									: "NIL"}
							</span>
						</div>
						{/* <div>
							<p>Address</p>
							<h3>{`${userProfile?.address ? userProfile?.address : "Not provided"}`}</h3>
						</div>
						<div>
							<p>Local Goverment Area</p>
							<h3>{`${userProfile?.lga ? userProfile?.lga : "Not provided"}`}</h3>
						</div> */}
					</div>
				</div>
			</header>
			<section className="p-6 bg-white rounded-lg mt-4">
				<AdminForm user={userProfile} />
			</section>
		</main>
	)
}

export default AdminProfile
